import React, { Component, ReactNode } from "react";
import classnames from "classnames";

import { Buttons } from "./Buttons";
import * as styles from "./ButtonsBar.scss";

export interface IButtonsBarProps {
    fixed?: boolean;
    collapsed?: boolean;
    minimal?: boolean;
    extra?: ReactNode;
    className?: string;
    children?: React.ReactNode;
}

export class ButtonsBar extends Component<IButtonsBarProps> {
    public render() {
        const { collapsed, fixed, extra, className, children, minimal } =
            this.props;

        return (
            <div
                className={classnames(
                    styles["buttons-bar"],
                    className,
                    fixed && styles.fixed,
                    collapsed && styles.collapsed,
                    minimal && styles.minimal,
                )}
            >
                {extra}
                <Buttons>{children}</Buttons>
            </div>
        );
    }
}
